// @core/api/endpoints/notifications/send_contact_verification.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SendContactVerificationRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Send verification code to contact
 * Initiates the contact verification process by sending a verification code to the contact address. The code can then be submitted to verify ownership.
 */
export async function SendContactVerification(
  contact_id: string,
  data: SendContactVerificationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/contacts/:contact_id/send-verification`;
  requestPath = requestPath.replace(':contact_id', encodeURIComponent(contact_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
